import './index.scss';
import React from 'react';
import { IOperateConfig, QuestionOperateType } from '../../../../interface/multiCapabilityTemplate';
import { lang } from '@umu/ukit-lang';
import { IfShow } from 'common/src/components';
import { Button } from '@umu/umu-design';
import { classSet } from '@umu/umu-dom';

interface IProps {
    currentIndex: number;
    operateConfig: IOperateConfig;
    children: React.ReactNode;
    onCommunication: (type: QuestionOperateType, data: any) => Promise<boolean>;
}

const getBtnList = (type: QuestionOperateType) => {
    if (type === QuestionOperateType.MOVE) {
        return [
            {
                index: QuestionOperateType.MOVE_TO,
                text: lang('移动到此'),
                type: 'primary',
            },
            {
                index: QuestionOperateType.CANCEL_OPERATE,
                text: lang('取消'),
                type: 'ghost-grey',
            },
        ];
    }
    if (type === QuestionOperateType.COPY) {
        return [
            {
                index: QuestionOperateType.COPY_TO,
                text: lang('复制到此'),
                type: 'primary',
            },
            {
                index: QuestionOperateType.CANCEL_OPERATE,
                text: lang('取消'),
                type: 'ghost-grey',
            },
        ];
    }
    return [];
};
const QuestionOperateConfig = (props: IProps) => {
    const { operateConfig, currentIndex, children, onCommunication } = props;
    const selectIndex = operateConfig.index;
    const btnList = getBtnList(operateConfig.type);
    const isShowTop = currentIndex < selectIndex;
    const isShowBottom = currentIndex > selectIndex;

    const eleBtnList = btnList.map((item) => {
        return (
            <Button
                key={item.index}
                type={item.type as any}
                className="config-btn-split"
                onClick={() => onCommunication(item.index, { index: isShowTop ? currentIndex : currentIndex + 1 })}
            >
                {item.text}
            </Button>
        );
    });
    return (
        <div
            className={classSet({
                'template-question-operate-config-info': true,
                'active': currentIndex === selectIndex && operateConfig.isShow,
            })}
        >
            <IfShow show={isShowTop && operateConfig.isShow}>
                <div className="config-btn-list btn-top">{eleBtnList}</div>
            </IfShow>
            {children}
            <IfShow show={isShowBottom && operateConfig.isShow}>
                <div className="config-btn-list btn-bottom">{eleBtnList}</div>
            </IfShow>
        </div>
    );
};
export { QuestionOperateConfig };
